import type { CommentReadEvent } from '../types/comment-read-event';
import type { Comment } from '../types/comment';

export class ReadEventsHelper {
  static getReadEvent(readEvents: CommentReadEvent[], participantId: string) {
    return readEvents.find(readEvent => readEvent.participantId === participantId);
  }

  static isLastReply(comment: Comment, index: number) {
    return comment.replies.length - 1 === index;
  }

  static filterOutParticipant(participantIds: string[], participantIdToFilterOut: string) {
    return participantIds.filter(participantId => participantId !== participantIdToFilterOut);
  }
}
